import { useNavigate } from 'react-router-dom'
import { Logo } from '../logo'
import { AppContext } from '../App'
import { useContext } from 'react'
import { clearProjectAction } from '../project'

const Header = ({ title, withLogo = false }) => {
  const navigate = useNavigate()
  const { dispatch } = useContext(AppContext)

  return (
    <div className='flex flex-row w-full justify-center'>
      {withLogo && (
        <div
          onClick={() => {
            navigate('/')
            dispatch(clearProjectAction())
          }}
          className='flex items-center cursor-pointer'
        >
          <Logo size='xs' />
        </div>
      )}
      <h1 className='text-5xl mb-5 mt-5 ml-3'>{title}</h1>
    </div>
  )
}

export { Header }
